import { Text } from '@mantine/core';
import { TbLock } from 'react-icons/tb';
import { EmptyState, Workspace } from '../v2';

export const NoAccessV2 = ({
  message = 'Ask an admin of your workspace for access, or go back to your projects.'
}) => (
  <Workspace id="no-access-container">
    <EmptyState
      icon={<TbLock id="no-access-icon" size={22} color="var(--dx-text-faint)" />}
      title={
        <Text id="no-access-title" span inherit>
          You don&apos;t have access to this page
        </Text>
      }
      description={
        <Text id="no-access-message" span inherit>
          {message}
        </Text>
      }
      action={{
        label: 'Go to projects',
        props: { id: 'no-access-go-home-button', component: 'a', href: '/project' }
      }}
    />
  </Workspace>
);
